import { EnvConfigService } from '../../core/services/config-handler/config-handler.service';

export function authConfigFactory() {
  return EnvConfigService.authConfig;
}
